import { Swiper, SwiperSlide } from "swiper/react";
import PhotoStockEpuise from "../../../stockepui.png"
import "swiper/css";
import "swiper/css/free-mode";
import logoWyn from "../../Admin/IMG/Logo.png"
import "./Homevisiteur.css";
import "../client/homeclient.css";
import DefaulteImage from "./DefaulteImage.jpeg";
import { Link, NavLink } from "react-router-dom";
import logoBrand from "../../Admin/IMG/Logo_Decathlon_RVB 1.png";
import { FormEvent, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArticleInfo } from "../../../Modeles/ArticleModel";
import AfficheProductsService from "../../../Services/Admin/AfficheProductsService";
import CardContainer from "../../../components/CardContainer";
import AfficheArticleInMagasin from "../../../Services/Magasin/AfficheArticleInMagasin";
import EmptyCartPopup from "../../../components/EmptyCartPopup";
import { Search } from "lucide-react";
import { MessageSends } from "../../../Services/Visiteure/SendMessageToWhatsapp";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import PanierLengVisiteur from "../../../Services/Panier/PanierLeng";
import BugReportButton from "../../../components/BugReportButton";
import HistoriqueVisiteur from "../../../Services/Visiteure/HistoriqueVisiteur";
import ArticlesLoader from "../../../components/ArticlesLoader";


const pageVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

interface PriceRange {
  label: string;
  value: [number, number];
}

export interface ProductType {
  product: ArticleInfo[];
  messageErros: string;
}

interface CardQuantities {
  [articleId: string]: number;
}

export default function HomeVisiteur() {
  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const [search, setSearch] = useState("");

  const [loading, setLoading]         = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [state, setState]             = useState<ProductType>({ product: [] as ArticleInfo[], messageErros: "aucun produit" });

  const [customRange, setCustomRange] = useState<{ min: string; max: string }>({ min: "", max: "" });
  const [priceRange, setPriceRange]   = useState<[number, number]>([0, 100000]);

  const predefinedRanges: PriceRange[] = [
    { label: "Tous les prix",          value: [0, 100000] },
    { label: "Moins de 10 000 DH",     value: [0, 10000] },
    { label: "10 000 DH à 50 000 DH",  value: [10000, 50000] },
    { label: "50 000 DH à 100 000 DH", value: [50000, 100000] },
  ];

  const visiteurId      = localStorage.getItem("VisiteurId") ?? "";
  const visiteurAdresse = localStorage.getItem("VisiteurAdresse");
  const visiteurName    = localStorage.getItem("VisiteurName");
  const visiteurTele    = localStorage.getItem("VisiteurTele");

  const [selectedPriceRange, setSelectedPriceRange] = useState<PriceRange | null>(null);
  const [Message, setMessage]           = useState("");
  const [alldata, setAlldata]           = useState<ArticleInfo[]>([]);
  const [currentPage, setCurrentPage]   = useState(1);
  const recordsPerPage = 20;
  const [totalPages, setTotalPages]     = useState(1);

  const [userLocation, setUserLocation]     = useState<{ latitude: number; longitude: number } | null>(null);
  const [MessageSucess, setMessageSucess]   = useState<string>("");
  const [MessageError, setMessageError]     = useState<string>("");
  const [filterLocation, setFilterLocation] = useState(false);
  const [filterMoinsCher, setFilterMoinsCher] = useState(false);
  const [filterDisponible, setFilterDisponible] = useState(false);

  /* ─── Per-card quantity ─── */
  const [cardQuantities, setCardQuantities] = useState<CardQuantities>({});
  const [addedToCart, setAddedToCart]       = useState<{ [id: string]: boolean }>({});
  const [addingToCartId, setAddingToCartId] = useState<string | null>(null);

  const getQuantity = (id: string) => cardQuantities[id] ?? 1;
  const changeQuantity = (id: string, delta: number) => {
    setCardQuantities(prev => {
      const next = Math.max(1, (prev[id] ?? 1) + delta);
      return { ...prev, [id]: next };
    });
  };
  const setQuantityDirect = (id: string, val: string) => {
    const parsed = parseInt(val);
    if (!isNaN(parsed) && parsed >= 1)
      setCardQuantities(prev => ({ ...prev, [id]: parsed }));
  };

  const [toast, setToast]               = useState<{ visible: boolean; name: string }>({ visible: false, name: "" });
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const fetchPanierLen = async () => {
    if (!visiteurId) return;
    try {
      const res = await PanierLengVisiteur(visiteurId, "Visiteurs").GetLenPanier();
      setPanierLen(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleAddToCart = async (pro: any) => {
    if (!visiteurName) { setShowLoginPopup(true); return; }
    const baseId = pro.IdArticle ?? pro.id ?? '';
    const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
    const qty = getQuantity(id);
    setAddingToCartId(id);
    try {
      const formData = new FormData();
      formData.append("IdUtilisateur",   visiteurId);
      formData.append("TypeUtilisiteur", "Visiteurs");
      formData.append("IdArticle",       id.toString());
      formData.append("RefArticle",      pro.RefArticle);
      formData.append("Designation",     pro.Designation);
      formData.append("Image",           pro.urlImage ? pro.urlImage : DefaulteImage);
      const cleanPrice = parseFloat(String(pro.PrixNetHT ?? pro.PrixVenteTTC ?? pro.PrixTTC ?? "0").replace(",", "."));
      const commission = getGlobalCommission();
      const finalPrice = isNaN(cleanPrice) ? 0 : cleanPrice * (1 + commission / 100);
      formData.append("price",           finalPrice.toFixed(2));
      formData.append("quantity",        qty.toString());
      formData.append("NomMagasin",      pro.NomMagasin);
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier`, formData);
      localStorage.setItem('cartExpiration', String(Date.now() + 50 * 60 * 1000)); // 50 minutes
      setAddedToCart(prev => ({ ...prev, [id]: true }));
      setToast({ visible: true, name: pro.Designation || "Produit" });
      setTimeout(() => setToast({ visible: false, name: "" }), 2800);
      // ✅ Refresh cart badge after successful add
      fetchPanierLen();
      window.dispatchEvent(new Event("panier-updated"));
    } catch (err) {
      console.error("Erreur ajout panier:", err);
    } finally {
      setAddingToCartId(null);
    }
  };

  const getDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const R = 6371; // Radius of the earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c * 2.13; // Distance in km (adjusted for driving)
    return d;
  };

  useEffect(() => {
    if (filterLocation && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos =>
        setUserLocation({ latitude: pos.coords.latitude, longitude: pos.coords.longitude })
      );
    }
  }, [filterLocation]);

  const [SeriMachine, setSeriMachine]     = useState<string>("");
  const [MarqueMachine, setMarqueMachine] = useState<string>("");
  const [AutreInfo, setAutreInfo]         = useState<string>("");
  const [isMobile, setIsMobile]           = useState(false);
  const [sidebarOpen, setSidebarOpen]     = useState(true);
  // const [showEmptyCartPopup, setShowEmptyCartPopup] = useState(false);
  const [commissionRules, setCommissionRules] = useState<any[]>([]);

  useEffect(() => {
    const fetchCommission = async () => {
      try {
        const r = await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/admin/commission`);
        setCommissionRules(r.data || []);
      } catch (err) {
        console.log(err);
        setCommissionRules([]);
      }
    };
    fetchCommission();
  }, []);

  const getGlobalCommission = (): number => {
    const globalRule = commissionRules.find((r: any) => r.commission_type === "global");
    if (globalRule) return parseFloat(globalRule.commission_value) || 0;
    return 0;
  };

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const [products, setProducts] = useState<ArticleInfo[]>([]);
  const [PanierLen, setPanierLen] = useState<any[]>([]);
  const [devisCount, setDevisCount] = useState<number>(0);
  const [historiqueCount, setHistoriqueCount] = useState<number>(0);
  const [Totale, setTotale] = useState<number>(0);

  useEffect(() => {
    let total = 0;
    if (Array.isArray(PanierLen)) {
      for (let i = 0; i < PanierLen.length; i++) {
        const priceVal = parseFloat(String(PanierLen[i].price).replace(",", "."));
        total += (isNaN(priceVal) ? 0 : priceVal) * Number(PanierLen[i].quantity);
      }
    }
    setTotale(total);
  }, [PanierLen]);

  const handleDeleteProduct = async (id: any) => {
    try {
      await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/panier/delete`, { id });
      setPanierLen((prev: any) => {
        const newArr = Array.isArray(prev) ? prev.filter((item: any) => item.id !== id) : prev;
        if (newArr.length === 0) {
          localStorage.removeItem('cartExpiration');
        }
        return newArr;
      });
      window.dispatchEvent(new Event("panier-updated"));
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ Load cart badge on mount + sync when any component updates the cart
  useEffect(() => {
    fetchPanierLen();
    const handleCartUpdate = () => fetchPanierLen();
    window.addEventListener("panier-updated", handleCartUpdate);

    // Fetch devis and historique counts for badges
    if (visiteurId && visiteurName) {
      axios.get(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/${visiteurId}/devis`)
        .then(res => setDevisCount(res.data.filter((d: any) => d.status === 'en cours').length))
        .catch(err => console.error(err));
        
      HistoriqueVisiteur().getHistoriqueVisiteur()
        .then(res => setHistoriqueCount(res.data.length))
        .catch(err => console.error(err));
    }

    return () => window.removeEventListener("panier-updated", handleCartUpdate);
  }, [visiteurId, visiteurName]);



  const initialArticlesRef = useRef<ArticleInfo[]>([]);
  const initialTotalPagesRef = useRef<number>(1);

  /* ── fetch products — passes active filters to the server, preserving full catalog pagination ── */
  const fetchProducts = async (page = 1, append = false, sortParam = '', disponibleParam = false) => {
    try {
      append ? setLoadingMore(true) : setLoading(true);
      const res = await AfficheArticleInMagasin().getAnly20Article(
        page,
        sortParam,
        disponibleParam,
        '',
        recordsPerPage
      );
      const fetched = res.data.data ?? [];
      setProducts(prev => append ? [...prev, ...fetched] : fetched);
      setAlldata(prev => append ? [...prev, ...fetched] : fetched);
      setCurrentPage(res.data.current_page);
      setTotalPages(res.data.total_pages);
      if (!append && page === 1 && sortParam === '' && !disponibleParam && initialArticlesRef.current.length === 0 && fetched.length > 0) {
        initialArticlesRef.current = fetched;
        initialTotalPagesRef.current = res.data.total_pages;
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  /* ── Removed redundant Initial load to prevent duplicate API call ── */

  /* ── Re-fetch from page 1 whenever filter buttons change ── */
  useEffect(() => {
    const sort = filterMoinsCher ? 'price_asc' : '';
    const activeCat = (selectedCategory && selectedCategory !== "Tous") ? selectedCategory : '';
    const anyFilterActive = search.trim() !== '' || activeCat !== '' || filterDisponible || filterMoinsCher;
    if (anyFilterActive) {
      // Always use getRef so server applies sort/disponible across the full merged dataset
      getRef(search.trim(), 1, false, sort, filterDisponible, selectedCategory);
    } else {
      fetchProducts(1, false, sort, filterDisponible);
      setRef([]); // clear ref so it uses products
    }
  }, [filterMoinsCher, filterDisponible]);


  const categories = [
    "CATERPILLAR", "VOLVO", "PERKINS", "KOMATSU", "JCB", "CUMMINS",
    "LEBRERO", "DOOSAN", "LIEBHERR", "HYUNDAI", "FIAT", "AMMANN", "POCLAIN",
  ];

  const [selectedCategory, setSelectedCategory] = useState<string | null>("Tous");

  const filteByCategory = async (categoryName: string, page = 1) => {
    try {
      let newCat: string | null = categoryName;
      if (selectedCategory === categoryName || categoryName === "Tous") {
        handleClearCategory();
        return;
      }
      setSelectedCategory(newCat);
      const sort = filterMoinsCher ? 'price_asc' : '';
      const currentQuery = searchInput.trim();
      setSearch(currentQuery);
      getRef(currentQuery, page, false, sort, filterDisponible, newCat);
    } catch (error) { console.error(error); }
  };

  const getRef = async (
    searchTerm: string,
    page: number = 1,
    append = false,
    sortParam = '',
    disponibleParam = false,
    catParam: string | null = selectedCategory
  ) => {
    try {
      const activeCat = (catParam && catParam !== "Tous") ? catParam : '';
      const queryToUse = searchTerm.trim();

      if (queryToUse === "" && !activeCat && sortParam === '' && !disponibleParam) {
        if (!append) {
          setRef([]);
          fetchProducts(1, false);
        }
        return;
      }
      if (append) {
        setLoadingMore(true);
      } else {
        setLoading(true);
        setRef([]);
      }
      const response = await axios.get(
        `${process.env.REACT_APP_PHP_APP_URL}/search-articles`,
        {
          params: {
            q: queryToUse,
            categorie: activeCat,
            page,
            perPage: recordsPerPage,
            sort: sortParam,
            disponible: disponibleParam ? '1' : ''
          }
        }
      );
      const newData   = response.data.data          ?? [];
      const curPage   = response.data.current_page  ?? page;
      const totPages  = response.data.total_pages   ?? 1;
      setRef(prev => append ? [...prev, ...newData] : newData);
      setCurrentPage(curPage);
      setTotalPages(totPages);
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const resetToDefault = () => {
    setSearch("");
    setSearchInput("");
    setSelectedCategory("Tous");
    setRef([]);
    setCurrentPage(1);
    setFilterMoinsCher(false);
    setFilterDisponible(false);
    setFilterLocation(false);
    setShowOtherInput(false);
    setOtherCategory("");
    if (initialArticlesRef.current.length > 0) {
      setProducts(initialArticlesRef.current);
      setAlldata(initialArticlesRef.current);
      setTotalPages(initialTotalPagesRef.current);
      setLoading(false);
    } else {
      fetchProducts(1, false);
    }
  };

  const handleClearCategory = () => {
    setSelectedCategory("Tous");
    setShowOtherInput(false);
    setOtherCategory("");
    const activeSearch = searchInput.trim() || search.trim();
    if (activeSearch !== "") {
      const sort = filterMoinsCher ? 'price_asc' : '';
      getRef(activeSearch, 1, false, sort, filterDisponible, "Tous");
    } else {
      resetToDefault();
    }
  };

  const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setSearchInput(val);
    if (val.trim() === "") {
      if (selectedCategory && selectedCategory !== "Tous") {
        setSearch("");
        const sort = filterMoinsCher ? 'price_asc' : '';
        getRef("", 1, false, sort, filterDisponible, selectedCategory);
      } else {
        resetToDefault();
      }
    }
  };

  const triggerSearch = () => {
    const val = searchInput.trim();
    setSearch(val);
    setRef([]);
    setCurrentPage(1);
    setTotalPages(0);
    const sort = filterMoinsCher ? 'price_asc' : '';
    getRef(val, 1, false, sort, filterDisponible, selectedCategory);
  };

  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") triggerSearch();
  };

  const handleSuivant = () => {
    if (currentPage >= totalPages) return;
    const nextPage = currentPage + 1;
    const activeSearch = searchInput.trim() || search.trim();
    const sort = filterMoinsCher ? 'price_asc' : '';
    const activeCat = (selectedCategory && selectedCategory !== "Tous") ? selectedCategory : '';
    if (activeSearch !== "" || activeCat !== "") {
      getRef(activeSearch, nextPage, true, sort, filterDisponible, selectedCategory);
    } else {
      fetchProducts(nextPage, true, sort, filterDisponible);
    }
  };

  const hasMore = currentPage < totalPages;

  /* ── Removed SaveTape persistence effect ── */

  const [showOtherInput, setShowOtherInput] = useState(false);
  const [otherCategory, setOtherCategory]   = useState("");
  const visibleCategories                   = categories.slice(0, 6);
  const [Refs, setRef]          = useState<any[]>([]);

  const filteredProducts = (Array.isArray(alldata) ? alldata : []).filter((pro: ArticleInfo) => {
    const refs = Array.isArray(pro.RefArticle) ? pro.RefArticle : [pro.RefArticle];
    const matchSearch =
      search === "" ||
      pro.Designation?.toLowerCase().includes(search.toLowerCase()) ||
      pro.RefArticle?.toString().toLowerCase().includes(search.toLowerCase()) ||
      refs.some(r => r?.toString().toLowerCase().includes(search.toLowerCase())) ||
      pro.DesignationAr?.toLowerCase().includes(search.toLowerCase()) ||
      pro.NomMarque?.toLowerCase().includes(search.toLowerCase());
    const matchCategory = !selectedCategory || selectedCategory === "Tous" ? true : pro.NomMarque === selectedCategory;
    const matchPrice    = (pro.PrixNetHT ?? 0) >= priceRange[0] && (pro.PrixNetHT ?? 0) <= priceRange[1];
    return matchSearch && matchCategory && matchPrice;
  });

  const normalizeString  = (str: string = "") => str.replace(/[-_.*\/?\\\s]/g, "").toLowerCase();
  const normalizedSearch = normalizeString(search);

  const filtedatas = products.filter((pro: ArticleInfo) => {
    const refs = Array.isArray(pro.RefArticle) ? pro.RefArticle : [pro.RefArticle];
    const matchText = (
      normalizeString(pro.Designation)?.includes(normalizedSearch) ||
      normalizeString(pro.RefArticle)?.includes(normalizedSearch) ||
      refs.some(ref => normalizeString(ref)?.includes(normalizedSearch)) ||
      normalizeString(pro.DesignationAr)?.includes(normalizedSearch)
    );
    // Also apply category filter client-side (safety-net when Refs is not used)
    const matchCat = !selectedCategory || selectedCategory === "Tous"
      ? true
      : (pro.NomMarque ?? '').toLowerCase().includes(selectedCategory.toLowerCase());
    return matchText && matchCat;
  });

  const [value, setValue]           = useState<[number, number]>([0, 100000]);
  const [isDragging, setIsDragging] = useState<number | null>(null);

  const handleMouseDown = (index: number) => (e: React.MouseEvent): void => { setIsDragging(index); };
  const handleMouseUp   = (): void => { setIsDragging(null); };
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>): void => {
    if (isDragging === null) return;
    const container = e.currentTarget.getBoundingClientRect();
    const position  = (e.clientX - container.left) / container.width;
    const newValue  = Math.round(position * 100000);
    if (isDragging === 0) { if (newValue < value[1]) setValue([Math.max(0, newValue), value[1]]); }
    else { if (newValue > value[0]) setValue([value[0], Math.min(100000, newValue)]); }
  };
  const handleInputChange = (index: number, inputValue: string) => {
    const newValue = parseInt(inputValue) || 0;
    if (index === 0) { if (newValue < value[1]) setValue([Math.max(0, newValue), value[1]]); }
    else { if (newValue > value[0]) setValue([value[0], Math.min(100000, newValue)]); }
  };

  const [showConfirmButton, setShowConfirmButton] = useState(false);

  const handleOpenWhatsApp = async () => {
    setLoading(true);
    const numeroAdmin = "212693693694";
    const message =
      SeriMachine === "" && MarqueMachine === "" && AutreInfo === ""
        ? `Quelqu'un recherche ce produit (${search}) Veuillez l'envoyer devis`
        : `Quelqu'un recherche ce produit (${search}) Veuillez l'envoyer devis voici quelque information : Serie Machine : ${SeriMachine || ""}, Marque Machine : ${MarqueMachine || ""} , autre information : ${AutreInfo || ""}`;
    try {
      const response = await fetch(`${process.env.REACT_APP_PHP_APP_URL}/visiteur/magasin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          MessageSend: message,
          Url: process.env.REACT_APP_PHP_APP_URL,
          visiteurId,
          ClientName: visiteurName,
          Type: "Demande de produit",
          Title: "Demande de produit",
        }),
      });
      if (!response.ok) throw new Error("Erreur lors de l'envoi au serveur");
      window.open(`https://wa.me/${numeroAdmin}?text=${encodeURIComponent(message)}`, "_blank");
      resetToDefault();
      setShowConfirmButton(true);
    } catch (error) {
      console.error("Erreur lors de l'envoi du message :", error);
    } finally {
      setLoading(false);
    }
  };

  const openWhatsApp = () => {
    const phone   = "212693693694";
    const message = encodeURIComponent("Bonjour wyn");
    const isMob   = /iPhone|Android|iPad/i.test(navigator.userAgent);
    window.open(
      isMob
        ? `https://api.whatsapp.com/send?phone=${phone}&text=${message}`
        : `https://web.whatsapp.com/send?phone=${phone}&text=${message}`,
      "_blank"
    );
  };

  /* ── Open WhatsApp with a "demande de prix" message for a specific product ── */
  const openDemandeWhatsApp = (pro: any) => {
    const phone   = "212693693694";
    const message = encodeURIComponent(
      `Bonjour, je souhaite me renseigner sur le prix du produit ${pro.Designation} (ref: ${pro.RefArticle})`
    );
    const isMob = /iPhone|Android|iPad/i.test(navigator.userAgent);
    window.open(
      isMob
        ? `https://api.whatsapp.com/send?phone=${phone}&text=${message}`
        : `https://web.whatsapp.com/send?phone=${phone}&text=${message}`,
      "_blank"
    );
  };

  const handlePredefinedRangeChange = (range: [number, number]) => {
    setPriceRange(range);
    setCustomRange({ min: "", max: "" });
  };
  const handleCustomRangeChange = (type: "min" | "max", val: string) => {
    setCustomRange({ ...customRange, [type]: val });
    setPriceRange([
      parseInt(customRange.min || "0"),
      parseInt(customRange.max || "100000"),
    ]);
  };

  const { product, messageErros } = state;

  // Build display list: Refs when search text OR active category/filter, otherwise unfiltered products
  const isFilterActive = search.trim() !== '' || (selectedCategory != null && selectedCategory !== 'Tous') || filterDisponible || filterMoinsCher;
  const displayList = (() => {
    let list = isFilterActive ? Refs : filtedatas;

    // If Refs is empty but a category/filter is active (still loading), fall back to client-side filtered list
    if (isFilterActive && Refs.length === 0 && !loading) {
      list = filtedatas;
    }
    
    // Apply "En stock" filter client-side
    if (filterDisponible) {
      list = list.filter((p: any) => {
        const qty = parseInt(String(p.Qte ?? p.Quantité ?? p.stock ?? p.quantity ?? 0));
        return qty > 0;
      });
    }
    
    // Apply "Moins cher" sort client-side
    if (filterMoinsCher) {
      list = [...list].sort((a: any, b: any) => {
        const paRaw = String(a.PrixNetHT ?? a.PrixVenteTTC ?? 0).replace(/ /g, "").replace(/,/g, ".");
        const pbRaw = String(b.PrixNetHT ?? b.PrixVenteTTC ?? 0).replace(/ /g, "").replace(/,/g, ".");
        const pa = parseFloat(paRaw) || 0;
        const pb = parseFloat(pbRaw) || 0;
        if (pa <= 0 && pb > 0) return 1;
        if (pa > 0 && pb <= 0) return -1;
        return pa - pb;
      });
    }

    // Apply "Proximité" (distance) sort client-side if filterLocation is active
    if (filterLocation && userLocation) {
      list = [...list].sort((a: any, b: any) => {
        const latA = parseFloat(a.latitude);
        const lonA = parseFloat(a.longitude);
        const latB = parseFloat(b.latitude);
        const lonB = parseFloat(b.longitude);
        
        const distA = getDistance(userLocation.latitude, userLocation.longitude, latA, lonA);
        const distB = getDistance(userLocation.latitude, userLocation.longitude, latB, lonB);
        
        const validA = !isNaN(distA) ? distA : Infinity;
        const validB = !isNaN(distB) ? distB : Infinity;
        
        return validA - validB;
      });
    }

    return list;
  })();



  /* ─── FIXED: safe price formatter — never crashes on undefined/null ─── */
  const calculatePriceWithCommission = (price: any, commission: any): string => {
    const cleanPrice = parseFloat(String(price ?? "0").replace(",", "."));
    const percentage = parseFloat(String(commission ?? "0").replace(",", "."));
    if (isNaN(cleanPrice) || isNaN(percentage)) return "0.00";
    const finalPrice = cleanPrice * (1 + percentage / 100);
    return finalPrice.toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  /* ── Premium Load-More button ── */
  const remainingCount = Math.max(0, (totalPages - currentPage) * 20);
  const progressPct   = totalPages > 0 ? Math.round((currentPage / totalPages) * 100) : 0;

  const SuivantBtn = () => (
    <div className="suivant-wrapper-hvu">
      {/* Progress bar */}
      <div className="suivant-progress-track-hvu">
        <div className="suivant-progress-fill-hvu" style={{ width: `${progressPct}%` }} />
      </div>
      <p className="suivant-hint-hvu">
        Page {currentPage} / {totalPages}&nbsp;·&nbsp;
        {remainingCount > 0 ? `+${remainingCount} produits restants` : "Tous les produits chargés"}
      </p>

      <button
        onClick={handleSuivant}
        disabled={loadingMore}
        className={`suivant-btn-hvu ${loadingMore ? "suivant-btn-loading-hvu" : ""}`}
      >
        {loadingMore ? (
          <>
            <span className="suivant-spinner-hvu" />
            <span>Chargement…</span>
          </>
        ) : (
          <>
            <span className="suivant-icon-hvu">
              <i className="bi bi-grid-3x3-gap-fill" />
            </span>
            <span>Charger plus de produits</span>
            {remainingCount > 0 && (
              <span className="suivant-badge-hvu">+{remainingCount}</span>
            )}
            <i className="bi bi-chevron-down suivant-arrow-hvu" />
          </>
        )}
      </button>
    </div>
  );

  /* ─────────────────── SHARED CARD RENDERER ─────────────────── */
  const renderProductCard = (pro: any, context: "desktop" | "mobile") => {
    const baseId = pro.IdArticle ?? pro.id ?? '';
    const id = baseId.toString() + '_' + (pro.NomMagasin ?? 'global');
    const encodedRef = btoa(pro.RefArticle);
    const qty        = getQuantity(id);
    const isAdded    = addedToCart[id] ?? false;
    const isAdding   = addingToCartId === id;
    const outOfStock = (pro.Quantité ?? pro.Qte ?? 0) <= 0;
    const imgSrc     = pro.urlImage ? pro.urlImage : DefaulteImage;

    /* ─── price-zero guard ─── */
    const rawPrice   = parseFloat(String(pro.PrixNetHT ?? "0").replace(",", "."));
    const isPriceZero = isNaN(rawPrice) || rawPrice === 0;

    return (
      <>
        {toast.visible && (
          <div className="cart-toast-hvu">
            <i className="bi bi-check-circle-fill" />
            <div>
              <span className="cart-toast-title-hvu">Produit ajouté au panier</span>
              <span className="cart-toast-sub-hvu">{toast.name}</span>
            </div>
          </div>
        )}
        <div className={`uc2-card-hvu ${outOfStock ? "uc2-card-nostock-hvu" : ""}`} key={id}>
          <div className="uc2-img-zone-hvu">
            {outOfStock ? (
              <img
                src={imgSrc}
                alt={pro.Designation}
                className={`uc2-img-hvu ${outOfStock ? "uc2-img-grey-hvu" : ""}`}
              />
            ) : (
              <Link to={`/visiteurs/${pro.NomMagasin}/articles/${encodedRef}`} style={{ display: 'block', height: '100%' }}>
                <img
                  src={imgSrc}
                  alt={pro.Designation}
                  className={`uc2-img-hvu ${outOfStock ? "uc2-img-grey-hvu" : ""}`}
                />
              </Link>
            )}
            <span className="uc2-brand-chip-hvu">{pro.NomMarque ? pro.NomMarque : "Pièce"}</span>
            {outOfStock ? (
              <div className="uc2-stock-badge-hvu uc2-stock-out-hvu">
                <i className="bi bi-x-circle-fill" /> Stock épuisé
              </div>
            ) : (
              <div className="uc2-stock-badge-hvu uc2-stock-in-hvu">
                {userLocation && pro.latitude && pro.longitude ? (
                  <><i className="bi bi-geo-alt-fill" /> {getDistance(userLocation.latitude, userLocation.longitude, parseFloat(pro.latitude), parseFloat(pro.longitude)).toFixed(2)} Km</>
                ) : (
                  <><i className="bi bi-check-circle-fill" /> En stock</>
                )}
              </div>
            )}
            {!outOfStock && (
              <button className="uc2-wish-btn-hvu" aria-label="Favoris">
                <i className="bi bi-suit-heart" />
              </button>
            )}
          </div>

          <div className="uc2-body-hvu">
            <div className="uc2-stars-hvu">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="bi bi-star-fill uc2-star-i-hvu" />
              ))}
            </div>

            {outOfStock ? (
              <div className="uc2-title-hvu">
                {pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
              </div>
            ) : (
              <Link className="uc2-title-link-hvu" to={`/visiteurs/${pro.NomMagasin}/articles/${encodedRef}`}>
                <div className="uc2-title-hvu">
                  {pro.Designation}{pro.DesignationAr ? ` | ${pro.DesignationAr}` : ""}
                </div>
              </Link>
            )}

            <p className="uc2-ref-hvu">Réf : {pro.RefArticle}</p>

            {/* ── Price — hidden when zero ── */}
            <div className="uc2-price-hvu">
              {isPriceZero ? (
                <span style={{ color: "#888", fontSize: "0.82rem", fontWeight: 500 }}>
                  Prix sur demande
                </span>
              ) : (
                <>
                  {calculatePriceWithCommission(pro.PrixNetHT, getGlobalCommission())}
                  <span className="uc2-currency-hvu"> MAD</span>
                </>
              )}
            </div>

            {/* ── Cart area — only for in-stock products ── */}
            {!outOfStock && (
              context === "mobile" ? (
                /* ── Mobile button ── */
                isPriceZero ? (
                  <button
                    className="mob-add-cart-btn-hvu btn-whatsapp-premium-hvu"
                    onClick={e => { e.preventDefault(); openDemandeWhatsApp(pro); }}
                  >
                    <i className="bi bi-whatsapp" /> Prix sur demande
                  </button>
                ) : (
                  <button
                    className={`mob-add-cart-btn-hvu ${isAdded ? "mob-add-cart-done-hvu" : ""}`}
                    onClick={e => { e.preventDefault(); handleAddToCart(pro); }}
                    title={visiteurName ? "Ajouter au panier" : "Connectez-vous d'abord"}
                    disabled={isAdding}
                  >
                    {isAdding ? (
                      <><span className="btn-spinner-hvu" /> Ajout...</>
                    ) : isAdded ? (
                      <><i className="bi bi-check-circle-fill" /> Ajouté</>
                    ) : (
                      <><i className="bi bi-cart-plus-fill" /> Ajouter</>
                    )}
                  </button>
                )
              ) : (
                /* ── Desktop row ── */
                isPriceZero ? (
                  <button
                    className="uc2-add-btn-hvu btn-whatsapp-premium-hvu"
                    style={{ width: "100%",flex: "1 1 10px"}}
                    onClick={e => { e.preventDefault(); openDemandeWhatsApp(pro); }}
                  >
                    <i className="bi bi-whatsapp" /> Prix sur demande
                  </button>
                ) : (
                  <div className="uc2-cart-row-hvu">
                    <div className="uc2-qty-hvu">
                      <button
                        className="uc2-qty-btn-hvu"
                        onClick={e => { e.preventDefault(); changeQuantity(id, -1); }}
                        aria-label="Moins"
                      >−</button>
                      <input
                        className="uc2-qty-input-hvu"
                        type="number"
                        min={1}
                        value={qty}
                        onClick={e => e.preventDefault()}
                        onChange={e => { e.preventDefault(); setQuantityDirect(id, e.target.value); }}
                      />
                      <button
                        className="uc2-qty-btn-hvu"
                        onClick={e => { e.preventDefault(); changeQuantity(id, +1); }}
                        aria-label="Plus"
                      >+</button>
                    </div>
                    <button
                      className={`uc2-add-btn-hvu ${isAdded ? "uc2-add-btn-done-hvu" : ""}`}
                      onClick={e => { e.preventDefault(); handleAddToCart(pro); }}
                      title={visiteurName ? "Ajouter au panier" : "Connectez-vous d'abord"}
                      disabled={isAdding}
                    >
                      {isAdding
                        ? <><span className="btn-spinner-hvu" /> Ajout...</>
                        : isAdded
                        ? <><i className="bi bi-check-lg" /> Ajouté</>
                        : <><i className="bi bi-cart-plus" /> Panier</>}
                    </button>
                  </div>
                )
              )
            )}
          </div>
        </div>
      </>
    );
  };

  /* ─────────────────────────────────────────── */

  return (
    <div style={{ backgroundColor: "#FAFAFA" }}>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css" />
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />

      {/* ── Login Required Popup ── */}
      {showLoginPopup && (
        <div className="login-popup-overlay-hvu" onClick={() => setShowLoginPopup(false)}>
          <div className="login-popup-hvu" onClick={e => e.stopPropagation()}>
            <button className="login-popup-close-hvu" onClick={() => setShowLoginPopup(false)}>
              <i className="bi bi-x-lg" />
            </button>
            <div className="login-popup-icon-hvu">
              <i className="bi bi-person-lock" />
            </div>
            <h3>Veuillez vous connecter</h3>
            <p>Vous devez être connecté pour accéder à votre espace (historique, devis, réclamation, profil) ou au panier.</p>
            <div className="login-popup-actions-hvu">
              <button
                className="login-popup-btn-primary-hvu"
                onClick={() => { setShowLoginPopup(false); navigate("/login"); }}
              >
                <i className="bi bi-box-arrow-in-right" /> Se connecter
              </button>
              <button className="login-popup-btn-secondary-hvu" onClick={() => setShowLoginPopup(false)}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
      <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>

      {isMobile ? (
        /* ══════════════ MOBILE VIEW ══════════════ */
        <div className="mobile-view-hvu">
          <EmptyCartPopup show={showEmptyCartPopup} onClose={() => setShowEmptyCartPopup(false)} />
          
          {/* ── Mobile Golden Welcome & Action Band ── */}
          <div className="mob-uppart-band-hvu">
            <div className="mob-uppart-welcome-text">
              {/* <i className="bi bi-stars mob-welcome-star" /> */}
              <span>Bienvenue sur la boutique en ligne <b>Wyn</b></span>
            </div>
            {visiteurName && (
              <div className="mob-uppart-nav-scroll">
                <NavLink to={`/visiteur/${visiteurId}/historiques`} className="mob-nav-pill-hvu">
                  <i className="bi bi-clock-history" />
                  <span>Historique</span>
                  {historiqueCount > 0 && <span className="mob-nav-badge-hvu">{historiqueCount}</span>}
                </NavLink>
                <NavLink to={`/visiteur/${visiteurId}/devis`} className="mob-nav-pill-hvu">
                  <i className="bi bi-file-earmark-text" />
                  <span>Devis</span>
                  {devisCount > 0 && <span className="mob-nav-badge-hvu">{devisCount}</span>}
                </NavLink>
                <NavLink to={`/visiteur/${visiteurId}/support?hideSidebar=true`} className="mob-nav-pill-hvu">
                  <i className="bi bi-headset" />
                  <span>Réclamation</span>
                </NavLink>
                <NavLink to={`/visiteur/${visiteurId}/profile`} className="mob-nav-pill-hvu">
                  <i className="bi bi-person-circle" />
                  <span>Profil</span>
                </NavLink>
              </div>
            )}
          </div>

          {/* ── Header ── */}
          <header className="header-hvu">
            <div className="header-top-row-hvu">
              <span className="mob-logo-hvu">W<span>yn</span></span>
              <div className="header-actions-hvu">
                {visiteurName ? (
                  <Link to="/logout" className="mob-icon-btn-hvu" title="Déconnecter">
                    <i className="bi bi-box-arrow-right" />
                  </Link>
                ) : (
                  <Link to="/login" className="mob-icon-btn-hvu" title="Se connecter">
                    <i className="bi bi-person" />
                  </Link>
                )}
                <a
                  href="#"
                  className="mob-icon-btn-hvu"
                  title="Panier"
                  onClick={e => {
                    e.preventDefault();
                    if (!visiteurName) setShowLoginPopup(true);
                    else if (!PanierLen || PanierLen.length === 0) setShowEmptyCartPopup(true);
                    else navigate("/visiteurs/panier");
                  }}
                >
                  {PanierLen && PanierLen.length > 0 && (
                    <span className="mob-icon-badge-hvu">{PanierLen.length}</span>
                  )}
                  <i className="bi bi-bag" />
                </a>
              </div>
            </div>
            <div className="search-bar-hvu">
              <input
                type="text"
                value={searchInput}
                onChange={handleSearchInputChange}
                onKeyDown={handleSearchKeyDown}
                placeholder="Rechercher pièces, réf..."
              />
              {searchInput.trim().length > 0 && (
                <i
                  className="bi bi-x-lg"
                  style={{ marginRight: 8, color: "rgba(255,255,255,0.5)", fontSize: 13, cursor: "pointer" }}
                  onClick={resetToDefault}
                />
              )}
              <i className="bi bi-search search-bar-icon-hvu" style={{ cursor: "pointer" }} onClick={triggerSearch} />
            </div>
          </header>

          {/* ── Category chips ── */}
          <div className="mob-categories-scroll-hvu">
            <button
              className={`mob-cat-chip-hvu ${selectedCategory === "Tous" || !selectedCategory ? "active-hvu" : ""}`}
              onClick={handleClearCategory}
            >Tous</button>
            {visibleCategories.map(cat => (
              <button
                key={cat}
                className={`mob-cat-chip-hvu ${selectedCategory === cat ? "active-hvu" : ""}`}
                onClick={() => { filteByCategory(cat); setShowOtherInput(false); }}
              >{cat}</button>
            ))}
            <button
              className={`mob-cat-chip-hvu ${showOtherInput ? "active-hvu" : ""}`}
              onClick={() => setShowOtherInput(!showOtherInput)}
            >Autre</button>
            {showOtherInput && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                
                  type="text"
                  placeholder="tape une categorie"
                  value={otherCategory}
                  onChange={(e) => setOtherCategory(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && otherCategory.trim() !== "") {
                      filteByCategory(otherCategory.trim());
                    }
                  }}
                  style={{ marginLeft: 8, padding: "4px 8px", borderRadius: 12, fontSize: 13 , color:"black"}}
                />
                <button
                  onClick={() => {
                    if (otherCategory.trim() !== "") filteByCategory(otherCategory.trim());
                  }}
                  style={{ marginLeft: 4, background: "#000", color: "#fff", border: "none", borderRadius: "50%", width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                  <i className="bi bi-search" style={{ fontSize: 10 }} />
                </button>
              </div>
            )}
          </div>

          {/* ── Filter bar ── */}
          <div className="mob-filter-bar-hvu" style={{ display: "flex", gap: "10px", overflowX: "auto", whiteSpace: "nowrap", paddingBottom: "8px", paddingTop: "4px" }}>
            <button
              className={`mob-premium-filter-btn-hvu ${filterMoinsCher ? "active" : ""}`}
              onClick={() => setFilterMoinsCher(v => !v)}
            >
              <i className="bi bi-graph-down-arrow" />
              <span>Moins chers</span>
            </button>
            <button
              className={`mob-premium-filter-btn-hvu ${filterDisponible ? "active" : ""}`}
              onClick={() => setFilterDisponible(v => !v)}
            >
              <i className="bi bi-box-seam" />
              <span>En stock</span>
            </button>
            <select
              className="mob-sort-select-hvu"
              onChange={e => setFilterLocation(e.target.value === "localisation")}
              style={{ flexShrink: 0 }}
            >
              <option value="">Trier: Tous</option>
              <option value="localisation">📍 Proximité</option>
            </select>
          </div>

          {/* ── Results bar ── */}
          <div className="mob-results-bar-hvu">
            <span><b>+45 000</b> produits disponibles</span>
            {selectedCategory && selectedCategory !== "Tous" && (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "var(--gold-hvu)", color: "var(--black-hvu)", padding: "2px 10px", borderRadius: 99, fontSize: 11, fontWeight: 700 }}>
                {selectedCategory}
                <i
                  className="bi bi-x-lg"
                  style={{ fontSize: 9, cursor: "pointer" }}
                  onClick={handleClearCategory}
                />
              </span>
            )}
          </div>

          {/* ── Product area ── */}
          {loading ? (
            <ArticlesLoader />
          ) : displayList.length > 0 ? (
            <AnimatePresence mode="wait">
              <motion.div initial="hidden" animate="visible" variants={pageVariants}>
                <div className="mobile-product-grid-hvu">
                  {displayList.map(pro => renderProductCard(pro, "mobile"))}
                </div>
                {hasMore && <SuivantBtn />}
              </motion.div>
            </AnimatePresence>
          ) : (
            <div className="no-produit-hvu" style={{ margin: "16px 12px", borderRadius: 16 }}>
              {MessageSucess && (
                <div className="alert alert-success" role="alert">
                  <i style={{ fontSize: "20px" }} className="bi bi-check-circle" /> {MessageSucess}
                </div>
              )}
              {MessageError && (
                <div className="alert alert-danger" role="alert">
                  <i style={{ fontSize: "20px" }} className="bi bi-x-circle" /> {MessageError}
                </div>
              )}
              {visiteurName ? (
                <>
                  <p>Ce produit n'est pas disponible</p>
                  <div style={{ width: "100%", maxWidth: 400, display: "flex", flexDirection: "column", gap: 8 }}>
                    <input type="text" className="form-control-hvu" placeholder="Serie de machine"  onChange={e => setSeriMachine(e.target.value)} />
                    <input type="text" className="form-control-hvu" placeholder="Marque de machine" onChange={e => setMarqueMachine(e.target.value)} />
                    <input type="text" className="form-control-hvu" placeholder="Autre information" onChange={e => setAutreInfo(e.target.value)} />
                  </div>
                  <Link
                    style={{ color: "white", cursor: "pointer", background: "#25D366", borderRadius: 8, padding: "10px 20px", display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}
                    onClick={e => { e.preventDefault(); handleOpenWhatsApp(); }}
                    to={""}
                  >
                    Veuillez nous contacter <i style={{ fontSize: "22px" }} className="bi bi-whatsapp" />
                  </Link>
                </>
              ) : (
                <>
                  <p>Malheureusement, aucun produit trouvé pour l'instant.</p>
                  <Link to="/login" className="login-connect-link-hvu">
                    Veuillez vous connecter <i style={{ fontSize: "18px" }} className="bi bi-box-arrow-in-right" />
                  </Link>
                </>
              )}
            </div>
          )}

          {/* ── Premium Bug Report Mobile Banner ── */}
          <div style={{ padding: "0 16px 24px" }}>
            <Link 
              to="/signaler-un-probleme" 
              className="mob-bug-report-banner-hvu"
            >
              <div className="mob-bug-icon-hvu">
                <i className="bi bi-shield-exclamation" />
              </div>
              <div className="mob-bug-text-hvu">
                <span className="mob-bug-title-hvu">Signaler un problème</span>
                <span className="mob-bug-sub-hvu">Aidez-nous à améliorer l'application</span>
              </div>
              <i className="bi bi-chevron-right mob-bug-arrow-hvu" />
            </Link>
          </div>

          {/* ── WhatsApp FAB ── */}
          <button className="mob-whatsapp-fab-hvu" onClick={openWhatsApp} aria-label="WhatsApp">
            <i className="bi bi-whatsapp" />
          </button>
        </div>

      ) : (
        /* ══════════════ DESKTOP VIEW ══════════════ */
        <div>
          <div className="u-uppart-visiteur-hvu">
            <div className="uppart-welcome-hvu">
              {/* <div className="uppart-welcome-icon-badge">
                <i className="bi bi-stars" />
              </div> */}
              <p className="uppart-welcome-text">
                <span>Bienvenue sur la boutique en ligne</span>
                <b className="uppart-brand-pill">Wyn</b>
              </p>
            </div>

            <div className="select-lang-om-hvu">
              {visiteurName ? (
                <>
                  <NavLink to={`/visiteur/${visiteurId}/historiques`} className="nav-action-pill-hvu">
                    <i className="bi bi-clock-history" />
                    <span>Historique</span>
                    {historiqueCount > 0 && <span className="nav-badge-pill-hvu">{historiqueCount}</span>}
                  </NavLink>

                  <NavLink to={`/visiteur/${visiteurId}/devis`} className="nav-action-pill-hvu">
                    <i className="bi bi-file-earmark-text" />
                    <span>Devis</span>
                    {devisCount > 0 && <span className="nav-badge-pill-hvu">{devisCount}</span>}
                  </NavLink>

                  <NavLink to={`/visiteur/${visiteurId}/support?hideSidebar=true`} className="nav-action-pill-hvu">
                    <i className="bi bi-headset" />
                    <span>Réclamation</span>
                  </NavLink>

                  <NavLink to={`/visiteur/${visiteurId}/profile`} className="nav-action-pill-hvu">
                    <i className="bi bi-person-circle" />
                    <span>Profil</span>
                  </NavLink>

                  <div className="nav-divider-hvu" />

                  <div className="user-dropdown-hvu dropdown">
                    <button className="user-pill-btn-hvu dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <span className="user-avatar-circle-hvu">{visiteurName.charAt(0).toUpperCase()}</span>
                      <span className="user-name-text-hvu">{visiteurName}</span>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end shadow-sm">
                      <li>
                        <Link className="dropdown-item d-flex align-items-center gap-2" to={`/visiteur/${visiteurId}/profile`}>
                          <i className="bi bi-person-circle text-primary" />Mon Profil
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center gap-2" to={`/visiteur/${visiteurId}/historiques`}>
                          <i className="bi bi-clock-history text-secondary" />Mes Commandes
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center gap-2" to={`/visiteur/${visiteurId}/devis`}>
                          <i className="bi bi-file-earmark-text text-secondary" />Mes Devis
                        </Link>
                      </li>
                      <li><hr className="dropdown-divider my-1" /></li>
                      <li>
                        <Link className="dropdown-item d-flex align-items-center gap-2 text-danger" to="/logout">
                          <i className="bi bi-box-arrow-left" />Déconnecter
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <button
                    type="button"
                    className="nav-cart-btn-hvu"
                    title="Mon Panier"
                    onClick={() => {
                      if (!PanierLen || PanierLen.length === 0) setShowEmptyCartPopup(true);
                      else navigate("/visiteurs/panier");
                    }}
                  >
                    <i className="bi bi-basket2" />
                    {PanierLen && PanierLen.length > 0 && (
                      <span className="nav-cart-badge-hvu">{PanierLen.length}</span>
                    )}
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="nav-login-btn-hvu" title="Se connecter">
                    <i className="bi bi-box-arrow-in-right" />
                    <span>Connexion</span>
                  </Link>

                  <button
                    type="button"
                    className="nav-cart-btn-hvu"
                    title="Mon Panier"
                    onClick={() => setShowLoginPopup(true)}
                  >
                    <i className="bi bi-basket2" />
                    {PanierLen && PanierLen.length > 0 && (
                      <span className="nav-cart-badge-hvu">{PanierLen.length}</span>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="u-uppart-second-hvu"><h2>Wyn.ma</h2></div>

          {/* ── Desktop search bar ── */}
          <div className="filter-Visiteur-hvu">
            <div className="filter-top-row-hvu">
              <div className="search-input-wrapper-hvu">
                <input
                  type="text"
                  onChange={handleSearchInputChange}
                  onKeyDown={handleSearchKeyDown}
                  value={searchInput}
                  placeholder="Chercher un produit, ref ..."
                />
                <i className="bi bi-search search-icon-hvu" style={{ cursor: "pointer" }} onClick={triggerSearch} />
                {searchInput.trim().length > 0 && (
                  <i className="bi bi-x-lg search-clear-hvu" style={{ cursor: "pointer" }} onClick={resetToDefault} />
                )}
              </div>
              <div className="sort-wrapper-hvu">
                <label>Trier par</label>
                <select className="sort-select-hvu" onChange={e => setFilterLocation(e.target.value === "localisation")}>
                  <option value="">Tous</option>
                  <option value="localisation">Votre localisation</option>
                </select>
              </div>
            </div>
            <div className="whatsapp-hint-hvu">
              Vous ne trouvez pas ce que vous cherchez ?&nbsp;
              <a onClick={openWhatsApp} href="#">contactez-nous par WhatsApp <i className="bi bi-whatsapp" /></a>
            </div>
          </div>

          <div className="main-layout-hvu" style={{ display: "grid", gridTemplateColumns: "240px 1fr 320px", gap: "20px" }}>
            {/* ── Sidebar ── */}
            <aside className="content-visiteures-hvu">
              {/* <button
                className="filter-toggle-btn-hvu"
                onClick={() => setSidebarOpen(prev => !prev)}
                aria-expanded={sidebarOpen}
              >
                <i className={`bi ${sidebarOpen ? "bi-funnel-fill" : "bi-funnel"}`} />
                {sidebarOpen ? "Masquer les filtres" : "Afficher les filtres"}
                <i className={`bi ${sidebarOpen ? "bi-chevron-up" : "bi-chevron-down"}`} style={{ marginLeft: "auto" }} />
              </button> */}

              <div className={`sidebar-collapsible-hvu${sidebarOpen ? "" : " collapsed-hvu"}`}>
                <div className="categories-visiteur-hvu">
                  <h5>Catégorie</h5>
                  <div className="category-list-hvu">
                    <button
                      className={`category-btn-hvu ${selectedCategory === "Tous" || !selectedCategory ? "selected-hvu" : ""}`}
                      onClick={handleClearCategory}
                    >
                      Tous
                    </button>
                    {visibleCategories.map((category, index) => (
                      <button
                        className={`category-btn-hvu ${selectedCategory === category ? "selected-hvu" : ""}`}
                        key={index}
                        onClick={() => { filteByCategory(category); setShowOtherInput(false); }}
                      >
                        {category}
                      </button>
                    ))}
                  </div>
                  <button className="show-more-btn-hvu" onClick={() => setShowOtherInput(!showOtherInput)}>
                    {showOtherInput ? "Masquer Autre ▲" : "Autre ▼"}
                  </button>
                  {showOtherInput && (
                    <div className="category-checkbox-hvu" style={{ marginTop: 8 }}>
                      <input
                        type="text"
                        placeholder="tape une categorie"
                        value={otherCategory}
                        onChange={(e) => setOtherCategory(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && otherCategory.trim() !== "") {
                            filteByCategory(otherCategory.trim());
                          }
                        }}
                        style={{ width: "100%", padding: "6px 10px", borderRadius: 8, border: "1px solid #ddd", outline: "none", fontSize: 13 , color:"black"}}
                      />
                      <button
                        onClick={() => {
                          if (otherCategory.trim() !== "") filteByCategory(otherCategory.trim());
                        }}
                        style={{ marginTop: 8, width: "100%", background: "#000", color: "#fff", border: "none", borderRadius: 8, padding: "6px", fontSize: 13 }}
                      >
                        Filtrer
                      </button>
                    </div>
                  )}

                  <div className="filter-price-range-hvu">
                    <hr className="price-divider-hvu" />
                    <h5>Options de Tri & Stock</h5>
                    
                    <button 
                      className={`premium-toggle-btn-hvu ${filterMoinsCher ? "active" : ""}`}
                      onClick={() => setFilterMoinsCher(v => !v)}
                    >
                      <div className="pt-icon-hvu">
                        <i className="bi bi-graph-down-arrow" />
                      </div>
                      <div className="pt-text-hvu">
                        <span className="pt-title-hvu">Moins chers</span>
                        <span className="pt-sub-hvu">Trier par prix croissant</span>
                      </div>
                      <div className="pt-status-hvu">
                        <i className={`bi ${filterMoinsCher ? "bi-check-circle-fill" : "bi-circle"}`} />
                      </div>
                    </button>

                    <button 
                      className={`premium-toggle-btn-hvu ${filterDisponible ? "active" : ""}`}
                      onClick={() => setFilterDisponible(v => !v)}
                    >
                      <div className="pt-icon-hvu">
                        <i className="bi bi-box-seam" />
                      </div>
                      <div className="pt-text-hvu">
                        <span className="pt-title-hvu">En stock</span>
                        <span className="pt-sub-hvu">Articles disponibles</span>
                      </div>
                      <div className="pt-status-hvu">
                        <i className={`bi ${filterDisponible ? "bi-check-circle-fill" : "bi-circle"}`} />
                      </div>
                    </button>
                    
                    <hr className="price-divider-hvu" />
                  </div>
                </div>
              </div>
            </aside>

            {/* ── Products area ── */}
            <div className="produit-container-hvu">
              <div className="filter-result-hvu">
                <span>
                  Filtres actifs :{" "}
                  {selectedCategory && selectedCategory !== "" && selectedCategory !== "Tous" ? (
                    <span className="active-filter-chip-hvu">
                      {selectedCategory}
                      <i className="bi bi-x-lg" onClick={handleClearCategory} />
                    </span>
                  ) : <b>tous</b>}
                </span>
                <span><b>+45 000</b> résultats trouvés</span>
              </div>

              {loading ? (
                <ArticlesLoader />
              ) : (
                <AnimatePresence mode="wait">
                  <motion.div initial="hidden" animate="visible" variants={pageVariants}>
                    <div className="product-grid-row-hvu">
                      {displayList.length > 0 ? (
                        displayList.map(pro => (
                          <div className="product-col-hvu" key={pro.IdArticle ?? pro.id}>
                            {renderProductCard(pro, "desktop")}
                          </div>
                        ))
                      ) : (
                        <div className="no-produit-hvu" style={{ gridColumn: "1/-1" }}>
                          {MessageSucess && (
                            <div className="alert alert-success">
                              <i className="bi bi-check-circle me-2" />{MessageSucess}
                            </div>
                          )}
                          {MessageError && (
                            <div className="alert alert-danger">
                              <i className="bi bi-x-circle me-2" />{MessageError}
                            </div>
                          )}
                          {visiteurName ? (
                            <>
                              <p>Ce produit n'est pas disponible</p>
                              <div style={{ width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", gap: 8 }}>
                                <input type="text" className="form-control-hvu" placeholder="Serie de machine"  onChange={e => setSeriMachine(e.target.value)} />
                                <input type="text" className="form-control-hvu" placeholder="Marque de machine" onChange={e => setMarqueMachine(e.target.value)} />
                                <input type="text" className="form-control-hvu" placeholder="Autre information" onChange={e => setAutreInfo(e.target.value)} />
                              </div>
                              <Link
                                style={{ color: "white", cursor: "pointer" }}
                                onClick={e => { e.preventDefault(); handleOpenWhatsApp(); }}
                                to={""}
                              >
                                Veuillez nous contacter{" "}
                                <i style={{ fontSize: "28px", marginLeft: "8px" }} className="bi bi-whatsapp" />
                              </Link>
                            </>
                          ) : (
                            <>
                              <p>Malheureusement, aucun produit trouvé pour l'instant.</p>
                              <Link to="/login" className="login-connect-link-hvu">
                                Veuillez vous connecter{" "}
                                <i style={{ fontSize: "18px" }} className="bi bi-box-arrow-in-right" />
                              </Link>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                    {hasMore && displayList.length > 0 && <SuivantBtn />}
                  </motion.div>
                </AnimatePresence>
              )}
            </div>

            {/* ── Panier Right Sidebar ── */}
            {visiteurName && (
              <div className="client-right-sidebar">
                <div className="client-cart-premium-box">
                  <div className="client-cart-header">
                    <span className="d-flex align-items-center gap-2">
                      <i className="bi bi-basket3 text-warning" /> Panier d'achat
                    </span>
                    <span className="badge bg-warning text-dark rounded-pill px-2.5 py-1">{(Array.isArray(PanierLen) ? PanierLen : []).length}</span>
                  </div>

                  {(Array.isArray(PanierLen) ? PanierLen : []).length > 0 ? (
                    <>
                      <div className="client-cart-items-list" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {(Array.isArray(PanierLen) ? PanierLen : []).map((item: any) => {
                          const cleanItemPrice = parseFloat(String(item.price ?? "0").replace(",", ".")).toFixed(2);
                          return (
                            <div key={item.id} className="client-cart-item">
                              <img src={item.Image ? item.Image : DefaulteImage} alt={item.Designation} className="client-cart-item-img" />
                              <div className="client-cart-item-info">
                                <div className="client-cart-item-name">{item.Designation}</div>
                                <div className="client-cart-item-qtyprice">
                                  Qté: {item.quantity} &bull; <span className="text-dark font-weight-bold">{cleanItemPrice} MAD</span>
                                </div>
                              </div>
                              <button
                                onClick={() => handleDeleteProduct(item.id)}
                                className="client-cart-item-delete"
                                title="Supprimer ce produit"
                              >
                                <i className="bi bi-x-circle-fill"></i>
                              </button>
                            </div>
                          );
                        })}
                      </div>

                      <div className="client-cart-footer">
                        <div className="client-cart-total d-flex justify-content-between align-items-center mb-3">
                          <span>Total HT/TTC :</span>
                          <span className="text-primary font-weight-bold h5 mb-0">{Totale.toFixed(2)} MAD</span>
                        </div>
                        <button className="client-checkout-btn text-center" onClick={() => (Array.isArray(PanierLen) ? PanierLen : []).length === 0 ? setShowEmptyCartPopup(true) : navigate(`/visiteurs/panier`)} style={{ border: 'none', cursor: 'pointer', width: '100%' }}>
                          <i className="bi bi-cart-check-fill me-1"></i> Consulter le panier
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-4 text-muted">
                      <i className="bi bi-cart-x text-muted" style={{ fontSize: '2rem' }}></i>
                      <p className="mt-2" style={{ fontSize: '0.82rem' }}>Votre panier est vide</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Floating Action Button for Bug Report */}
      <BugReportButton />
    </div>
  );
}